// ?tab=team&modal=add-freelancer (TD-106, DD-045): someone the agency pays who is not on the team and never signs in. A name
// and an email, the email required (DD-056: marked before it is touched, and a line says why Add waits). An email that already
// has a person links to them, and a name another agency gave them stays (TD-086), which the toast says. The Team tab then
// lists them as External.
import { useState } from "react";
import { Button } from "@/components/ui/Button";
import { FormField, inputClassName } from "@/components/ui/FormField";
import { ENTITY_CONFIG } from "@/core/entityConfig";
import { FinanceDrawer } from "../components/FinanceDrawer";
import { MissingLine, Required } from "../components/Required";
import { useAddFreelancer } from "../hooks/useLedger";
import { useSubmitOnce } from "../hooks/useSubmitOnce";
import { closeUnlessPending, shownError } from "../utils/mutations";
import { FREELANCER_INTRO, freelancerCheck, freelancerInput } from "../utils/people";

const FORM_ID = "add-freelancer-form";

export function AddFreelancerModal({ onClose }: { onClose: () => void }) {
  const add = useAddFreelancer();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [touched, setTouched] = useState(false);
  const check = freelancerCheck(name, email);
  const send = useSubmitOnce();
  const save = () => {
    setTouched(true);
    if (check.blocked) return;
    send(() => add.mutateAsync(freelancerInput(name, email)), () => onClose());
  };
  return (
    <FinanceDrawer
      onClose={closeUnlessPending(add.isPending, onClose)}
      title={ENTITY_CONFIG.freelancer.createLabel}
      footer={
        <>
          <Button type="submit" form={FORM_ID} disabled={check.blocked || add.isPending} isLoading={add.isPending}>Add</Button>
        </>
      }
    >
      <form
        id={FORM_ID}
        className="space-y-3 text-sm"
        onSubmit={(e) => {
          e.preventDefault();
          save();
        }}
      >
        <p className="text-gray-600">{FREELANCER_INTRO}</p>
        <FormField label="Name" error={check.nameError}>
          <input className={inputClassName} aria-label="Name" value={name} onChange={(e) => setName(e.target.value)} autoFocus />
        </FormField>
        <FormField
          label={<Required>Email</Required>}
          error={shownError(check.emailError ?? undefined, touched && email.trim() !== "")}
        >
          <input
            className={inputClassName}
            aria-label="Email"
            aria-required="true"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={() => setTouched(true)}
          />
        </FormField>
        <MissingLine button="Add" missing={email.trim() === "" ? ["their email"] : []} />
      </form>
    </FinanceDrawer>
  );
}
